"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "valdaora": {
    "valdaora-di-sopra": [{
      "hkey": "b9b0d1c3",
      "slug": "valdaora-di-mezzo-e-di-sopra",
      "name": "Valdaora di Mezzo e di Sopra",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "valdaora"
    }],
    "17d364d0": [{
      "hkey": "b9b0d1c3",
      "slug": "valdaora-di-mezzo-e-di-sopra",
      "name": "Valdaora di Mezzo e di Sopra",
      "primary": true,
      "skipSearch": false
    }],
    "valdaora-di-mezzo": [{
      "hkey": "b9b0d1c3",
      "slug": "valdaora-di-mezzo-e-di-sopra",
      "name": "Valdaora di Mezzo e di Sopra",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "aa4b6f71": [{
      "hkey": "b9b0d1c3",
      "slug": "valdaora-di-mezzo-e-di-sopra",
      "name": "Valdaora di Mezzo e di Sopra",
      "primary": true,
      "skipSearch": false
    }]
  }
};
exports["default"] = _default;